export const TERMS_URL = "https://bit.ly/2M5cBAG";
export const POLICY_URL = "https://bit.ly/38PWBN1";
export const CONTACT_WHATSAPP_URL = "https://api.whatsapp.com/send?phone=5584999071952";
export const CONTACT_EMAIL = "contato@ifeiraoficial.com.br";
export const APP_IOS_STORE_LINK = "itms-apps://apps.apple.com/br/app/id1482214816";
export const APP_ANDROID_STORE_LINK = "market://details?id=com.ifeirasoftwares.ifeira";
